<template>
  <div>
    <!-- Positive Trend -->
    <b-icon
      v-if="Difference > 0 && !inverted"
      icon="triangle-fill"
      variant="success"
    ></b-icon>
    <b-icon
      v-if="Difference < 0 && inverted"
      icon="triangle-fill"
      variant="success"
    ></b-icon>

    <!-- Negative Trend -->
    <b-icon
      v-if="Difference < 0 && !inverted"
      icon="triangle-fill"
      variant="danger"
      rotate="180"
    ></b-icon>
    <b-icon
      v-if="Difference > 0 && inverted"
      icon="triangle-fill"
      variant="danger"
      rotate="180"
    ></b-icon>

    <!-- No change -->
    <b-icon
      v-if="Difference == 0"
      icon="circle-fill"
      variant="warning"
    ></b-icon>
  </div>
</template>

<script>
export default {
  props: {
    Difference: Number, // new value - old value
    inverted: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
div {
  font-size: 0.6rem;
  height: 100%;
  display: inline-flex;
  align-items: center;
}
</style>